import { styled } from '@mui/material';
import { colors } from './colors';

export const NotFoundWrapper = styled('div')`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex-grow: 1;
`;

export const NotFoundHeader = styled('h1')`
  font-size: 36px;
  color: ${colors.blue};
`;